export const CalendarSVG = (props) => (
  <svg
    height={32}
    viewBox="0 0 33 32"
    width={33}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="#1d1d1b">
      <path d="M3.478 8.536h29.01M10.462 0v6.537M24.993 0v6.537M30.197 31.239a1.936 1.936 0 01-1.936-1.936v-2.125H1v2.125c0 1.069.866 1.936 1.936 1.936" />
      <path d="M3.478 27.178V3.268h29.01v23.988-.078 2.126a1.935 1.935 0 01-1.936 1.935H2.935" />
      <g>
        <path d="M7.136 16.57h3.57V13h-3.57zM13.02 16.57h3.57V13h-3.57zM18.901 16.57h3.57V13h-3.57zM24.784 16.57h3.57V13h-3.57zM13.02 22.933h3.57v-3.57h-3.57zM18.901 22.933h3.57v-3.57h-3.57zM24.784 22.933h3.57v-3.57h-3.57zM7 21.148l1.308 1.267 2.534-2.534" />
      </g>
    </g>
  </svg>
);
